import type {ClientFetch} from '../util/clientFetch';
import type {ConversationsApiEndConversationEndpointResponse} from '../../../generated/types';

export type EndConversationResponse =
  | Extract<ConversationsApiEndConversationEndpointResponse, {type: 'success'}>
  | {type: 'error'; error: string; code?: number};

export async function endConversation(
  supportFetch: ClientFetch,
  conversationId: string,
): Promise<EndConversationResponse> {
  let response: Response;
  try {
    response = await supportFetch(
      `/api/v2/conversations/${encodeURIComponent(conversationId)}/end`,
      {method: 'POST'},
    );
  } catch {
    return {
      type: 'error',
      error: 'Failed to end conversation',
    };
  }

  let data: ConversationsApiEndConversationEndpointResponse;
  try {
    data =
      (await response.json()) as ConversationsApiEndConversationEndpointResponse;
  } catch {
    return {
      type: 'error',
      error: 'Failed to parse end conversation response',
      code: response.status,
    };
  }

  if (!response.ok || data.type !== 'success') {
    return {
      type: 'error',
      error:
        data.type === 'success' ? 'Failed to end conversation' : data.error,
      code: response.status,
    };
  }

  return data;
}
